import type { Xinglet } from '@xing-com/crate-xinglet';

import { Registration } from './registration';

export default class RegistrationXinglet implements Xinglet {
  public getComponent() {
    return (): JSX.Element => <Registration />;
  }
}
